export const reel = {
	REEL_COEFFS_CNT: {
		config: {
			fill: '#43B726',
			fontFamily: 'Poppins SemiBold',
			fontSize: 30
		}
	},
	REEL_COEFFS_AMT: {
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 30
		}
	},
	REEL_COEFFS_CNT_SMALL: {
		config: {
			fill: '#43B726',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	REEL_COEFFS_AMT_SMALL: {
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	}
};
